import React from 'react';
import ArtofStoryTelling2025 from '../views/ArtofStoryTelling2025';

const ExtraCurricularActivitiesPage = () => {
  return <ArtofStoryTelling2025/>;
};

export default ExtraCurricularActivitiesPage;
